/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import { React, useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Modal, Drawer, AppBar, ListItemAvatar, Avatar, Toolbar, Typography, TextField, Button, Paper, List, ListItem, ListItemText } from "@mui/material";
import Detail from "./components/detail";
import Create from "./components/create";
import {
  saveUser,
  deleteUser,
  updateUser,
  getUsers,
  getRoles,
  getOrganizations
} from "context";

const drawerWidth = 240;


function Organization() {
  const [open, setOpen] = useState(false);
  const [users , setusers] = useState([]);
  const [roles , setroles] = useState([]);
  const [orgs , setorgs] = useState([]);
  const handleOpen = () => {
    setOpen(true)
    setuser(null);
  }
  const handleClose = () => setOpen(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setuser] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  useEffect(() => {
    FetchUsers();
    FetchRoles();
    FetchOrgs();
  }, [])


  const FetchUsers =  async () => {
    let resp = await getUsers();
    setusers(resp.data.resp)
  }
  const FetchRoles =  async () => {
    let resp = await getRoles();
    setroles(resp.data.resp)
  }
  const FetchOrgs =  async () => {
    let resp = await getOrganizations();
    setorgs(resp.data.resp)
  }
  
  const editForm = (user) => {
    
    setuser(user);
    setOpen(true);
  }
  
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
 const handleEdit = () => {
    handleMenuClose();
    onEdit();
  };

  // const handleDelete = () => {
  //   handleMenuClose();
  //   onDelete();
  // };





  const handleSave = async (data) => {
    
    // Call User and refresh data
    if(data.id > 0)
    {
      
      await updateUser(data);
    }
    else{
      
      await saveUser(data);
    }
    FetchUsers(); // Refresh after save
    handleClose();
  };

  const handleDelete = async (orgId) => {
    // Call deleteOrganization and refresh data
    await deleteOrganization(orgId);
    FetchOrg(); // Refresh after delete
  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <Grid spacing={12} sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}>
          <MDButton color={"info"} onClick={handleOpen} >ADD new </MDButton>
        </Grid>
      </MDBox>
      <MDBox sx={{ minHeight:"75vh"  }}>
        <Grid container spacing={3} mt={1}>
        {
            users.map((value) => (
                <Grid item xs={3} key={value.id} >
                  <Detail
                    view={value}
                    edit={editForm}
                    delete={() => handleDelete(value)}
                  />
                </Grid>
            )
            )
          }
       </Grid>
      </MDBox>


      <Modal open={open} onClose={handleClose}>
        <Create data={user} organizations={orgs} roles={roles} saveRecord={handleSave} />
      </Modal>
      <Footer />
    </DashboardLayout>
  );
}

export default Organization;
